require("source-map-support").install(), function (n, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define("Separator", [], e) : "object" == typeof exports ? exports.Separator = e() : n.Separator = e();
}(this, function () {
  return function (n) {
    var e = {};

    function t(r) {
      if (e[r]) return e[r].exports;
      var o = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return n[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }

    return t.m = n, t.c = e, t.d = function (n, e, r) {
      t.o(n, e) || Object.defineProperty(n, e, {
        enumerable: !0,
        get: r
      });
    }, t.r = function (n) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(n, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(n, "__esModule", {
        value: !0
      });
    }, t.t = function (n, e) {
      if (1 & e && (n = t(n)), 8 & e) return n;
      if (4 & e && "object" == typeof n && n && n.__esModule) return n;
      var r = Object.create(null);
      if (t.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: n
      }), 2 & e && "string" != typeof n) for (var o in n) {
        t.d(r, o, function (e) {
          return n[e];
        }.bind(null, o));
      }
      return r;
    }, t.n = function (n) {
      var e = n && n.__esModule ? function () {
        return n.default;
      } : function () {
        return n;
      };
      return t.d(e, "a", e), e;
    }, t.o = function (n, e) {
      return Object.prototype.hasOwnProperty.call(n, e);
    }, t.p = "/", t(t.s = 415);
  }({
    1: function _(n, e) {
      n.exports = require("prop-types");
    },
    10: function _(n, e, t) {
      "use strict";

      var r = t(3),
          o = t.n(r),
          i = t(1),
          f = t.n(i),
          u = t(2);

      function a() {
        var n = o()(["\n  align-content: ", ";\n  align-items: ", ";\n  align-self: ", ";\n  display: ", ";\n  flex-basis: ", ";\n  flex-direction: ", ";\n  flex-grow: ", ";\n  flex-shrink: ", ";\n  flex-wrap: ", ";\n  justify-content: ", ";\n  order: ", ";\n  overflow: ", ";\n"]);
        return a = function a() {
          return n;
        }, n;
      }

      var l = t.n(u).a.div(a(), function (n) {
        return n.alignContent;
      }, function (n) {
        return n.alignItems;
      }, function (n) {
        return n.alignSelf;
      }, function (n) {
        return n.inline ? "inline-flex" : "flex";
      }, function (n) {
        return n.flexBasis;
      }, function (n) {
        return n.flexDirection;
      }, function (n) {
        return n.flexGrow;
      }, function (n) {
        return n.flexShrink;
      }, function (n) {
        return n.flexWrap ? "wrap" : "nowrap";
      }, function (n) {
        return n.justifyContent;
      }, function (n) {
        return n.order;
      }, function (n) {
        return n.overflow;
      });
      l.propTypes = {
        alignContent: f.a.string,
        alignItems: f.a.string,
        alignSelf: f.a.string,
        flexBasis: f.a.oneOfType([f.a.number, f.a.string]),
        flexDirection: f.a.string,
        flexGrow: f.a.number,
        flexShrink: f.a.number,
        flexWrap: f.a.bool,
        inline: f.a.bool,
        justifyContent: f.a.string,
        overflow: f.a.string,
        order: f.a.number
      }, l.defaultProps = {
        alignContent: "stretch",
        alignItems: "stretch",
        alignSelf: "auto",
        flexBasis: "auto",
        flexDirection: "row",
        flexGrow: 0,
        flexShrink: 1,
        flexWrap: !1,
        inline: !1,
        justifyContent: "flex-start",
        order: 0,
        overflow: "hidden"
      }, l.displayName = "FlexContainer", e.a = l;
    },
    2: function _(n, e) {
      n.exports = require("styled-components");
    },
    200: function _(n, e, t) {
      "use strict";

      t.r(e);
      var r = t(68);
      e.default = r.a;
    },
    3: function _(n, e) {
      n.exports = require("@babel/runtime/helpers/taggedTemplateLiteral");
    },
    415: function _(n, e, t) {
      n.exports = t(200);
    },
    68: function _(n, e, t) {
      "use strict";

      var r = t(3),
          o = t.n(r),
          i = t(1),
          f = t.n(i),
          u = t(2),
          a = t.n(u),
          l = t(10);

      function c() {
        var n = o()(["\n  flex-basis: 100%;\n  \n  color: ", ";\n  font-family: ", ";\n  font-size: ", 'px;\n  margin: 20px 0;\n  \n  &::before, &::after {\n    display: block;\n    content: "";\n    flex-grow: 1;\n    background-color: ', ";\n    height: 1px;\n    font-size: 0;\n    line-height: 0;\n  }\n  \n  &::before {\n    margin-right: ", "px;\n  }\n  \n  &::after {\n    margin-left: ", "px;\n  }\n"]);
        return c = function c() {
          return n;
        }, n;
      }

      var s = a()(l.a).attrs({
        alignItems: "center",
        children: function children(n) {
          return n.children || n.text;
        }
      })(c(), function (n) {
        return n.theme.colors.grey;
      }, function (n) {
        return n.theme.fonts.Body1.fontFamily;
      }, function (n) {
        return n.theme.fonts.Body1.fontSize;
      }, function (n) {
        var e = n.light,
            t = n.theme.colors;
        return e ? t.grey20 : t.grey40;
      }, function (n) {
        return n.text ? 23 : 0;
      }, function (n) {
        return n.text ? 23 : 0;
      });
      s.displayName = "Separator", s.propTypes = {
        text: f.a.string,
        light: f.a.bool
      }, s.defaultProps = {
        text: "",
        light: !1
      }, e.a = s;
    }
  });
});